import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { forgotPassword } from "../../api/client";
import "../Login/login.scss";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email.trim()) {
      setErrorMessage("Please enter your email address.");
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      await forgotPassword(email.trim());
      setSuccessMessage("Reset instructions have been sent to your email.");
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand" aria-label="Hin Ho Lee Trading Sdn. Bhd.">
          <span>興和利貿易有限公司</span>
          <strong>Hin Ho Lee Trading Sdn. Bhd.</strong>
        </div>

        <h1 className="login-page__title login-page__title--compact">Forgot password</h1>
        <p className="login-page__subtitle login-page__subtitle--compact">
          Enter your email address and we will send you instructions to reset your password.
        </p>

        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="login-page__field">
            <span className="login-page__icon">
              <Icon icon="ph:user-fill" height={18} />
            </span>
            <input
              className="login-page__input"
              type="email"
              placeholder="Email"
              value={email}
              autoComplete="email"
              disabled={Boolean(successMessage)}
              onChange={(event) => {
                setEmail(event.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          {successMessage && (
            <div className="login-page__message login-page__message--success">
              {successMessage}
            </div>
          )}

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          {!successMessage ? (
            <button type="submit" className="login-page__submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send reset instructions"}
            </button>
          ) : (
            <Link className="login-page__submit login-page__submit-link" to="/login">
              Back to login
            </Link>
          )}
        </form>

        {!successMessage && (
          <p className="login-page__footer-link">
            <Link className="login-page__link" to="/login">
              Back to login
            </Link>
          </p>
        )}
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default ForgotPasswordPage;
